import axios from "axios";

const baseUrl = `${import.meta.env.VITE_API_ELASTIC}`
const apiURL = `${import.meta.env.VITE_API_URL}`

export const buscaRegistroService = {
  obterRegistros: (payload) => {
    return axios.post(`${baseUrl}/obter-registro`, payload, {
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJDUkMgTmFjaW9uYWwiLCJpYXQiOjE2NzkzMTYwMDYsImV4cCI6NDA3NzYwNzIwNiwiYXVkIjoic2lzdGVtYS5yZWdpc3Ryb2NpdmlsLm9yZy5iciIsInN1YiI6InN1cG9ydGUuY3JjQHJlZ2lzdHJvY2l2aWwub3JnLmJyIiwiR2l2ZW5OYW1lIjoiQ1JDIiwiU3VybmFtZSI6Ik5hY2lvbmFsIn0.5DXatIJyOtIPADeUl7KAILFmQGUKspE3VR-IWKanDEw'
      }
    });
  },

  obterDetalhes: (payload) => {
    return axios.post(`${baseUrl}/obter-detalhes`, payload, {
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJDUkMgTmFjaW9uYWwiLCJpYXQiOjE2NzkzMTYwMDYsImV4cCI6NDA3NzYwNzIwNiwiYXVkIjoic2lzdGVtYS5yZWdpc3Ryb2NpdmlsLm9yZy5iciIsInN1YiI6InN1cG9ydGUuY3JjQHJlZ2lzdHJvY2l2aWwub3JnLmJyIiwiR2l2ZW5OYW1lIjoiQ1JDIiwiU3VybmFtZSI6Ik5hY2lvbmFsIn0.5DXatIJyOtIPADeUl7KAILFmQGUKspE3VR-IWKanDEw'
      }
    });
  },

  obterDadosSERPRO: (payload) => {
    return axios.post(`${apiURL}/obter-dados-serpro`, payload, null);
  },

  /*gravarLog: (payload) => {

    return axios.post(`${baseUrl}/gravar-log`, payload, {
      headers: {
          'Content-Type': 'application/json',
      }
    });

  },*/

};